import {TextMedium} from '@hm/fundamental'
import {CircularProgress} from '@material-ui/core'
import React from 'react'

import {RoleUpmHierarchyChip} from '../../components/Role/RoleUpmHierarchyChip'
import {useTranslation} from '../../hooks/useTranslation'
import {useUpmHierarchySummary} from '../../hooks/useUpmHierarchySummary'
import {GroupedRoleAssignment} from '../../modules/ManageUsers.selectors'

type UpmPlantsProps = {
  groupedRoleAssignment: GroupedRoleAssignment
}

const normalizeToArray = (value: string | string[] | undefined): string[] => {
  if (!value) {
    return []
  }

  return Array.isArray(value) ? value : [value]
}

export const UpmPlants = ({groupedRoleAssignment}: UpmPlantsProps) => {
  const {t} = useTranslation()
  const upmHierarchyIds = normalizeToArray(groupedRoleAssignment.commonDataScopes.upmHierarchyIds)
  const upmIds = normalizeToArray(groupedRoleAssignment.commonDataScopes.upmIds)
  const scopeIds = upmHierarchyIds.length > 0 ? upmHierarchyIds : upmIds
  const selectedScopeLabel =
    upmHierarchyIds.length > 0
      ? t('roleAssignment.selectedHierarchies')
      : t('roleAssignment.selectedPlants')
  const hierarchySummaryQueryInfo = useUpmHierarchySummary({hierarchyIds: scopeIds})

  if (scopeIds.length === 0) {
    return null
  }

  if (hierarchySummaryQueryInfo.isLoading) {
    return <CircularProgress size="20" />
  }

  if (hierarchySummaryQueryInfo.isError) {
    return <TextMedium className="text-foreground">{t('roleAssignment.labelFetchError')}</TextMedium>
  }

  return (
    <div className="flex flex-col gap-3">
      <TextMedium>{selectedScopeLabel}</TextMedium>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
        {(hierarchySummaryQueryInfo.data || []).map((item) => (
          <RoleUpmHierarchyChip key={item.hierarchyId} item={item} />
        ))}
      </div>
    </div>
  )
}
